// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__8iXfc","checked":"CheckBox_checked__Csf7t","lg":"CheckBox_lg__Msmrt"};